import { createApp } from 'vue'
import { createPinia } from 'pinia'

import './boot' // 必須最先：在 './router' 載入前處理主題與 OAuth hash
import App from './App.vue'
import { router } from './router'

import './styles/tokens.css'
import './styles/app.css'
import './styles/ui.css'

createApp(App).use(createPinia()).use(router).mount('#app')
